import { MuiAutocomplete } from 'src/theme/components/MuiAutocomplete';
import { MuiButton } from 'src/theme/components/MuiButton';
import { MuiCheckbox } from 'src/theme/components/MuiCheckbox';
import { MuiChip } from 'src/theme/components/MuiChip';
import { MuiCircularProgress } from 'src/theme/components/MuiCircularProgress';
import { MuiFormControl } from 'src/theme/components/MuiFormControl';
import { MuiFormControlLabel } from 'src/theme/components/MuiFormControlLabel';
import { MuiFormHelperText } from 'src/theme/components/MuiFormHelperText';
import { MuiFormLabel } from 'src/theme/components/MuiFormLabel';
import { MuiIconButton } from 'src/theme/components/MuiIconButton';
import { MuiInputAdornment } from 'src/theme/components/MuiInputAdornment';
import { MuiLink } from 'src/theme/components/MuiLink';
import { MuiModal } from 'src/theme/components/MuiModal';
import { MuiOutlinedInput } from 'src/theme/components/MuiOutlinedInput';
import { MuiPaper } from 'src/theme/components/MuiPaper';
import { MuiRadio } from 'src/theme/components/MuiRadio';
import { MuiSelect } from 'src/theme/components/MuiSelect';
import { MuiSwitch } from 'src/theme/components/MuiSwitch';
import { MuiTab } from 'src/theme/components/MuiTab';
import { MuiTabs } from 'src/theme/components/MuiTabs';

export const components = {
  MuiFormControl,
  MuiFormControlLabel,
  MuiFormLabel,
  MuiFormHelperText,
  MuiOutlinedInput,
  MuiAutocomplete,
  MuiSelect,
  MuiInputAdornment,
  MuiButton,
  MuiIconButton,
  MuiCheckbox,
  MuiLink,
  MuiModal,
  MuiTabs,
  MuiTab,
  MuiChip,
  MuiRadio,
  MuiCircularProgress,
  MuiSwitch,
  MuiPaper,
};
